export default __webpack_public_path__ + "static/avatar-mp-kayi-male-0-v3-cover-4bc27084427a6dd3b839ddff6b46e969.png";